import './TaxonomyApprovalComponent.scss'
import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../stores";
import {Alert, Button, Chip, Dialog, Grid, TextField} from "@mui/material";
import {useNavigate, useParams} from "react-router";
import {ApprovalStatusEnum, ApprovalTypeEnum} from "../../../services/classes/AiClasses";
import {ApprovalStore} from "../../../stores/ApprovalStore";
import {APPROVAL_DIALOG_TITLE_ID} from "../ApprovalDialog";
import {TaxonomyApprovalAcceptDialog} from "./TaxonomyApprovalAcceptDialog";
import {TaxApprovalReviewTable} from "./TaxonomyApprovalReviewTable";
import {TaxonomyApprovalReviewButtonBar} from "./toolbar/TaxonomyApprovalReviewButtonBar";
import {EditCategoryModal} from "./modals/EditCategoryModal";
import {MoveCategoryModal} from "./modals/MoveCategoryModal";
import {DeleteCategoryModal} from "./modals/DeleteCategoryModal";
import {CreateCategoryModal} from "./modals/CreateCategoryModal";
import {ChevronRight} from "@mui/icons-material";

export const TaxonomyApprovalComponent: React.FC = observer(() => {
    const params = useParams();
    const navigate = useNavigate();
    const {approvalStore} = useStores();
    const ta = approvalStore.taxonomyApproval;

    const a = approvalStore.taxonomyApprovalRequest;
    const canEditApproval = ApprovalStatusEnum.statusIsOpenForApprover(a?.current_status.status);

    // The magic that loads the data
    useEffect(() => approvalStore.onLoadApprovalPage(ApprovalTypeEnum.TAXONOMY, params, navigate),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [])

    return (<div className="taxonomy-approval-component">
        <Dialog
            open={approvalStore.isAcceptApprovalDialogOpen}
            onClose={() => approvalStore.clickAwayApprovalDialog()}
            aria-labelledby={APPROVAL_DIALOG_TITLE_ID}
            maxWidth="lg"
        >
            {approvalStore.isAcceptApprovalDialogOpen && <TaxonomyApprovalAcceptDialog/>}
        </Dialog>
        <Dialog
            open={ta.isEditDialogOpen}
            onClose={() => ta.closeDialogs()}
            maxWidth="lg"
        >
            {ta.editNode && <EditCategoryModal node={ta.editNode}/>}
            {ta.moveNode && <MoveCategoryModal node={ta.moveNode}/>}
            {ta.deleteNode && <DeleteCategoryModal node={ta.deleteNode}/>}
            {ta.createNode && <CreateCategoryModal node={ta.createNode}/>}
        </Dialog>
        {a &&
            <Grid component="section" className="intro" container justifyContent="center" alignItems="center">
                <Grid size={{
                        md: 6,
                        xs: 10
                    }}>
                    {<>
                        <TextField
                            multiline
                            fullWidth
                            label="Notes for the reviewer"
                            variant="filled"
                            value={a.notes || ''}
                            inputProps={{readOnly: true}}
                        />
                        <br/>
                        <TextField
                            multiline
                            fullWidth
                            label="Reply"
                            variant={!canEditApproval ? 'filled' : 'outlined'}
                            value={a.feedback_notes || ''}
                            onChange={e => ta.setFeedbackNotes(e.target.value)}
                            inputProps={{readOnly: !canEditApproval}}
                        />
                    </>}
                </Grid>
                <Grid
                      container direction="column" alignItems="center"
                    size={{
                        md: 2,
                        xs: 2
                    }}>
                    {canEditApproval
                        ? <Grid>
                            <Button
                                variant="outlined"
                                className="m-2"
                                onClick={() => {
                                    approvalStore.openSendApprovalDialog();

                                    // noinspection JSIgnoredPromiseFromCall
                                    approvalStore.taxonomyApproval.ensureApprovalNotesSaved(); // in background
                                }}
                                endIcon={<ChevronRight/>}
                                disabled={approvalStore.taxonomyApproval.isBusy}
                            >
                                Save notes and finish review
                            </Button>
                        </Grid>
                        : <Grid>
                            <Chip
                                label={ApprovalStore.getApprovalStatusName(a.current_status.status)}
                                className={`chip taxonomy-approval-status-${a.current_status.status}`}/>
                        </Grid>
                    }
                    {ta.errorMessage &&
                        <Grid>
                            <Alert severity="error">
                                {ta.errorMessage}
                            </Alert>
                        </Grid>
                    }
                </Grid>
            </Grid>
        }

            <TaxonomyApprovalReviewButtonBar/>

            <TaxApprovalReviewTable/>
        </div>
    );
})
